<template>
    <div id="mmy-input" v-if="makes">
        <loading-overlay :active.sync="displayLoader" id="loader" loader="dots" color="#1A74DB" height="100%" width="100%" opacity="0.85">
            <template v-slot:after>
                <h3> {{ webstoreContent.selectProductsPage.getting_cables }} </h3>
            </template>
        </loading-overlay>
        <template v-if="!displayLoader">
            <div v-for="(row, index) in mmyData" :key="index">
                <emea-mmy-row :makes="makes" :emeaCableData="emeaCableData" :row="row" :index="index"></emea-mmy-row>
            </div>
            <div class="flex flex-between" id="add-vehicle-container">
                <v-button
                    position="left"
                    mobile="12"
                    tablet="12"
                    desktop="12"
                    styling="tertiary"
                    :disabled="false"
                    @onClickEvent="addEmeaMMYRow">
                    <template v-slot:content>
                        <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM12 8.8H8.8V12H7.2V8.8H4V7.2H7.2V4H8.8V7.2H12V8.8Z" fill=""/>
                            </svg>
                            {{ addRowText }}
                        </span>
                        </template>
                </v-button>
                <v-button
                    position="right"
                    mobile="12"
                    tablet="12"
                    desktop="12"
                    styling="secondary"
                    :disabled="false"
                    @onClickEvent="submitMMYDataHandler">
                    <template v-slot:content>
                        {{ webstoreContent.selectProductsPage.save }}
                    </template>
                </v-button>
            </div>
        </template>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';
    import axios from 'axios';
    import EmeaMmyRow from './emea-mmy-row';
    import vButton from '../utils/button';
    import CableSelectionValidations from '../../mixins/cable-selection-validation'

    export default {

        mixins: [CableSelectionValidations],

        components: {EmeaMmyRow, vButton},

        data() {
            return {
                displayLoader: false,
                makes: [],
                emeaCableData: {},
            }
        },

        computed: {
            ...mapGetters([
                'activeProductKey',
                'activeOfferKey',
            ]),

            ...mapGetters('content', [
                'webstoreContent',
            ]),

            cablesNeededCount() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesNeededCount`];
            },

            cablesSelectedCount() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesSelectedCount`];
            },

            mmyData() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/mmyData`];
            },

            addRowText() {
                return this.activeProductKey === "AG26" ? this.webstoreContent.cartPage.add_asset : this.webstoreContent.cartPage.add_vehicle;
            }
        },

        methods: {
            addEmeaMMYRow() {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/addEmeaMMYRow`);
            },

            submitMMYDataHandler: async function() {
                if (this.calculateMaxCableSubmissionQuantity("mmy") > this.cablesNeededCount) {
                    this.fireIncorrectCablesSelectedCountAlert(this.cablesSelectedCount, this.cablesNeededCount);
                    return false;
                }

                if (!this.areMMYRowsCompleted()) {
                    this.fireIncompleteMMYAlert()
                    return false;
                }

                if (!this.mmyData || !this.isAtleastOneRowCompleted()) {
                    this.clearSubmittedMMYData();
                    return;
                }
                try {
                    this.displayLoader = true;
                    await this.$store.dispatch(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/submitMMYData`);
                    this.displayLoader = false;
                } catch(e) {
                    this.$router.push({path: '/message', query: {type: 'errorCheckingOut'}});
                    return;
                }
            }
        },
        async mounted() {
            let { data } = await axios('/webstore/emea-cables');
            this.emeaCableData = data;
            this.makes = Object.keys(data);
        },
    }
</script>

<style scoped>

    #mmy-input {
        font-family: "Nitti Grotesk", sans-serif;
        font-style: normal;
        font-weight: normal;
    }

    #add-mmy-row-button {
        cursor: pointer;
        background-color: transparent;
        border: none;
        font-size: 22px;
        font-weight: 500;
        color: #474F54;
        line-height: 22px;
        margin: 0 auto;
        margin-top: 20px;
    }

    #add-mmy-row-button:hover {
        box-shadow: none;
        color: #00263E;
    }

    #add-mmy-row-button:focus {
        outline: none;
    }

</style>

